var map = {
	"./ei_transfers_icon.svg": 1079,
	"./mainNavigationChevron_icon.svg": 1080,
	"./schedule_icon.svg": 1081,
	"./sports-news_icon.svg": 1082,
	"./sports_icon.svg": 1083,
	"./table_icon.svg": 1084,
	"./transfers_icon.svg": 1085,
	"./worldnews_icon.svg": 1086
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1300;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/.*_icon\.svg$
// module id = 1300
// module chunks = 33